import { gql } from '@apollo/client';

// Operation name `StudentPendingSurveys` is deliberately distinct from the
// backend field `mySurveys` — equal operation/field names make codegen collapse
// the generated result type into the schema payload type (graphql-codegen skill).
// The payload carries the full question list, so filling a survey needs no
// second request (spec 0011 §4).
export const StudentPendingSurveysQuery = gql`
  query StudentPendingSurveys {
    mySurveys {
      assignmentId
      title
      description
      groupName
      lessonName
      lessonNumber
      teacherName
      questions {
        id
        number
        text
        questionType
        required
        options
      }
    }
  }
`;
